import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  constructor(private readonly translateService: TranslateService) {}

  getTitleBase(func: (param: string) => void) {
    this.translateService
      .get('browsertitle.base')
      .subscribe((translation: string) => {
        func(translation);
      });
  }

  getTitleExtension(url: string, func: (param: string) => void) {
    if (url.indexOf('/', 1) != -1) {
      url = url.substring(0, url.indexOf('/', 1));
    }
    this.translateService
      .get('browsertitle.' + url)
      .subscribe((translation: string) => {
        func(translation);
      });
  }
}
